import React, { useState } from 'react';
import { Slider, Stack, Typography } from '@mui/material';
import { Edit } from '../constructor/work/Edit';

export const SettingsComponent = () => {
  const [scalePoints, setScalePoints] = useState(() => {
    if (Edit.sectionsObjects?.controlsPointsObjects.length) {
      return Edit.sectionsObjects.controlsPointsObjects[0].scale.x;
    }
    return 1;
  });
  // const [scaleLine, setScaleLine] = useState(1);

  const handlerChangeSlider = (event: Event, value: number | number[]) => {
    setScalePoints(+value);
    Edit.sectionsObjects?.updateScaleControlObjects(+value);
  };
  /* const handlerChangeSliderLine = (event: Event, value: number | number[]) => {
    setScaleLine(+value);
  };*/

  return (
    <Stack display="flex">
      <Typography fontSize={24} color="#fff">
        НАСТРОЙКИ
      </Typography>
      <Typography mb={3} color="#fff">
        Задайте длину сторон
      </Typography>
      <Typography color="white" gutterBottom>
        Масштаб точек
      </Typography>
      <Slider
        // onMouseDown={handlerSliderClick}
        value={scalePoints}
        onChange={handlerChangeSlider}
        valueLabelDisplay="auto"
        step={0.05}
        min={0.5}
        max={3}
      />
      {/* <Typography color="white" gutterBottom>
        Масштаб линий
      </Typography>
      <Slider
        // onMouseDown={handlerSliderClick}
        value={scaleLine}
        onChange={handlerChangeSliderLine}
        valueLabelDisplay="auto"
        step={0.05}
        min={0.5}
        max={1.5}
      />*/}
    </Stack>
  );
};
